import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Home from '../views/Home.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    props: {
      showHeadButton: true,
      showHeadIn: true,
      hideMagazineForm: true,
      top: true,
      title: 'スズキ | スズキ定額マイカー',
    },
  },
  {
    path: '/car',
    component: () => import('@/views/Car/Index.vue'),
    props: {
      title: 'クルマ検索 | スズキ定額マイカー',
    },
  },
  {
    path: '/car/:chassisNumber',
    component: () => import('@/views/Car/Detail.vue'),
    props: {
      title: 'クルマ詳細 | スズキ定額マイカー',
    },
  },
  {
    path: '/apply/input1/:chassisNumber',
    component: () => import('@/views/Apply/Input1.vue'),
    props: {
      title: 'お申し込み | スズキ定額マイカー',
    },
  },
  {
    path: '/apply/completion/:chassisNumber',
    component: () => import('@/views/Apply/Complete.vue'),
    props: {
      title: 'お申し込み完了 | スズキ定額マイカー',
    },
  },
  {
    path: '/inquiry',
    component: () => import('@/views/Inquiry/Input.vue'),
    props: {
      title: 'お問い合わせ | スズキ定額マイカー',
    },
  },
  {
    path: '/inquiry/completion',
    component: () => import('@/views/Inquiry/Complete.vue'),
    props: {
      title: 'お問い合わせ完了 | スズキ定額マイカー',
    },
  },
  {
    path: '/shop',
    component: () => import('@/views/Shop/Index.vue'),
    props: {
      showHeadIn: true,
      showHeadButton: true,
      title: '店舗情報 | スズキ定額マイカー',
    },
  },
  {
    path: '/faq',
    component: () => import('@/views/Faq/Index.vue'),
    props: {
      showHeadIn: true,
      showHeadButton: true,
      title: 'よくある質問 | スズキ定額マイカー',
    },
  },
  {
    path: '/flow',
    component: () => import('@/views/Flow/Index.vue'),
    props: {
      showHeadIn: true,
      showHeadButton: true,
      title: 'ご利用の流れ | スズキ定額マイカー',
    },
  },
  {
    path: '/service',
    component: () => import('@/views/Service/Index.vue'),
    props: {
      showHeadIn: true,
      showHeadButton: true,
      title: 'サービスの詳細 | スズキ定額マイカー',
    },
  },
  {
    path: '/terms/use',
    component: () => import('@/views/Terms/Use.vue'),
    props: {
      title: '利用規約 | スズキ定額マイカー',
    },
  },
  {
    path: '/terms/tokushouhou',
    component: () => import('@/views/Terms/Tokushouhou.vue'),
    props: {
      title: '特定商取引法に基づく表示 | スズキ定額マイカー',
    },
  },
  {
    path: '/terms/privacy',
    component: () => import('@/views/Terms/Privacy.vue'),
    props: {
      title: '個人情報の取り扱いについて | スズキ定額マイカー',
    },
  },
  {
    // サーバーエラー
    path: '/error',
    component: () => import('@/components/Page.vue'),
    props: {
      error: 500,
    },
  },
  {
    // 混雑中
    path: '/error/busy',
    component: () => import('@/components/Page.vue'),
    props: {
      error: 503,
    },
  },
  {
    // 在庫切れ
    path: '/no-stock',
    component: () => import('@/components/Page.vue'),
    props: {
      error: 5000,
    },
  },
  {
    // Not Found Error
    path: '/:pathMatch(.*)*',
    component: () => import('@/components/Page.vue'),
    props: {
      error: 404,
    },
  },
];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const scrollBehavior = (to: any, from: any, savedPosition: any) => {
  if (savedPosition) {
      return savedPosition;
  }

  if (to.hash) {
      const el = document.getElementById(to.hash.replace('#', ''));
      return el ? {top: el.offsetTop - 80 } : { top: 0 };
  }

  return { top: 0 };
};


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: scrollBehavior,
});

export default router;
